/**
 * Store: Menu drawer
 * -----------------------------------------------------------------------------
 * Tracks the background image for the menu drawer tiers.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    backgroundImage: '',
  }),

  mutations: {

    /**
     * Set background image.
     * @param {String} url - Background image url.
     */
    SET_BACKGROUND_IMAGE(state, url) {
      state.backgroundImage = url
    },
  },

  actions: {

    /**
     * Set background image.
     * @param {String} url - Backgroun image url.
     */
    setBackgroundImage({ commit }, url = '') {
      commit('SET_BACKGROUND_IMAGE', url)
    },
  },
}
